import { render, staticRenderFns } from "./SaleAdd.vue?vue&type=template&id=177e331a&scoped=true&"
import script from "./SaleAdd.vue?vue&type=script&lang=js&"
export * from "./SaleAdd.vue?vue&type=script&lang=js&"
import style0 from "./SaleAdd.vue?vue&type=style&index=0&id=177e331a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177e331a",
  null
  
)

export default component.exports